<template>
  <div class="vip-detail-account">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="vipDetailAccountInfo.accounts" border style="width: 100%" v-loading="loading">
        <el-table-column prop="vipAcctId" label="账户编号" align="center"></el-table-column>
        <el-table-column prop="acctName" label="账户名称" align="center"></el-table-column>
        <el-table-column label="账户类型" align="center">
          <template #default>现金</template>
        </el-table-column>
        <el-table-column prop="amount" label="账户金额" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      </el-table>

      <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShopVipAccount } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailAccount',
  data() {
    return {
      vipDetailAccountInfo: {
        accounts: [],
        vipId: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailAccountInfo.vipId = data.vipId
      this.loadVipDetailAccountData()
    },
    loadVipDetailAccountData() {
      if (!this.vipDetailAccountInfo.vipId) return

      this.loading = true
      const params = {
        vipId: this.vipDetailAccountInfo.vipId,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getShopVipAccount(params)
        .then(res => {
          this.vipDetailAccountInfo.accounts = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取账户数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadVipDetailAccountData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadVipDetailAccountData()
    }
  }
}
</script>

<style scoped>
.vip-detail-account {
  padding: 20px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>